import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { DataBankService } from 'src/app/services/DataBankService';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { CanserModel } from 'src/app/models/CanserModel';
import { PathologyModel } from 'src/app/models/PathologyModel';
import { GovernmentsModel, MasterdataModel } from 'src/app/models/Masterdata.Model';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { DoctorsService } from 'src/app/services/DoctorsService';

@Component({
  selector: 'app-patient-info',
  templateUrl: './patient-info.component.html',
  styleUrls: ['./patient-info.component.css']
})
export class PatientInfoComponent implements OnInit {
  patientCode = '';
  patientName = '';
  patientFName = '';
  patientLName = '';
  birthDate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  diagnosis = '';
  marital = '';
  gov = 'القاهرة';
  nationality ='Egyptian';
  occupation = '';
  email = '';
  telMobile = '';
  telHome = '';
  addressHome = '';
  cancerID = '';
  docCode = '';
  education = '';
  status = '';
  ageYear ='0';
  gender = '';
  telBusin='';
  pathology = '';
  compCode = '1';
  userID='john';
  ageYear1 =0;
  birthDate_V :any;
  Today = formatDate(new Date(), 'yyyy', 'en');
  day1 :any;
  recid = '0';
  pattime = formatDate(new Date(), 'HH:mm', 'en');
    ////----------Mortality -----------------
        mortalitypatientcode = '' ;
        mortalitydeath = formatDate(new Date(), 'yyyy-MM-dd', 'en');
        mortalidate = '' ;
        mortalityreason = '' ;
        mortalitynotes = '' ;

        wk_Hied_Mortal = false;
        mstatustext ='';
    ///----------------------------------------
    dateEntry = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    yearEntry = formatDate(new Date(), 'yyyy', 'en');
    currenttime = formatDate(new Date(), 'HH:mm', 'en');

    doctorsList: DoctorsModel[] = [];
    cancerlist:CanserModel[] = [];
    PathologyList:PathologyModel[]=[];

    MasterListNa:MasterdataModel[]=[];
    MasterListGov:GovernmentsModel[]=[];
    MasterListNat:MasterdataModel[]=[];

    MasterList1:MasterdataModel[]=[];
    MasterList2:MasterdataModel[]=[];
    MasterList3:MasterdataModel[]=[];
    companyList: CompanyModel[] = [];
    doctorname = '';
  @Output() submitClicked = new EventEmitter<any>();
  constructor(
    public dataBankService: DataBankService,
    public dataBankModel: DatabankModel,
    public doctorservice : DoctorsService,
    public dialogRef: MatDialogRef<PatientInfoComponent>,
    @Inject(MAT_DIALOG_DATA)public data: any
  ) {
       this.patientCode = data.patientcode;

  }

  ngOnInit(): void {
    this.retrievePatient();
  }
 retrievePatient() {

    this.dataBankService.getPatient(this.patientCode, this.compCode).subscribe((data: DatabankModel) => {

      this.patientFName =  data.patientFName;/// this.storage.retrieve('stpatientname');//data.patientFName;
      this.ageYear = data.ageYear;
      this.birthDate =formatDate(data.birthDate,'yyyy-MM-dd','en') ;
      this.diagnosis = data.diagnosis;
      this.gender = data.gender;
      this.marital = data.marital;
      this.telMobile = data.telMobile;
      this.cancerID = data.cancerID;
      this.addressHome = data.addressHome;
      this.docCode= data.docCode;
      this.doctorservice.getdoctors(this.docCode, '1').subscribe((data: DoctorsModel) => {
          this.doctorname = data.docName;
        }

      );
      this.email = data.email;
      this.telHome = data.telHome;
      this.pathology = data.pathology;
      this.marital=data.marital;
      this.status = data.status;
      this.compCode = data.compCode;

      this.email = data.email;
      this.education = data.education;
      this.occupation = data.occupation;
      this.nationality = data.nationality;
      this.gov = data.gov;
      this.status = data.status;
      this.telBusin = data.telBusin;
      this.dateEntry = formatDate(data.dateEntry,'yyyy-MM-dd','en');
      if(data.marital == '0'){this.mstatustext ='Single'};
      if(data.marital == 'Married'){this.mstatustext ='Married'};
      if(data.marital == '2'){this.mstatustext ='Divorced'}; 
      if(data.marital == '3'){this.mstatustext ='Widow/Widower'};
      if(data.marital == '4'){this.mstatustext ='Separated'}
      

      });
    }
    CloseDialog(){
      this.dialogRef.close();
    }

}
